// Client-side exports
export { AuthProvider } from './AuthProvider';
export { PermissionProvider } from './PermissionProvider';
export { useAuth } from './useAuth';
export { usePermissions } from './usePermissions';
export { useRouteGuard } from './useRouteGuard';
export { useMcpConnectionsAccess } from './mcp-connections-access';
export { useFirstPermittedRoute } from './useFirstPermittedRoute';
export { useLoginForm } from './useLoginForm';

// Types
export type {
  LoginCredentials,
  LoginResponse,
  SessionResponse,
  RefreshResponse,
  SwitchRoleResponse,
  AuthContextValue,
  PermissionContextValue,
  ActiveSession,
} from './types';

export type { SessionLimitState } from './useLoginForm';
export type { FirstPermittedRouteState } from './useFirstPermittedRoute';
